import ServiciosGeneral from "./ServiciosGeneral";

const servicios = {
  getSolicitudes: ServiciosGeneral.llamarServidor("/Solicitud/getSolicitudes"),
  insertSolicitud: ServiciosGeneral.llamarServidorRespuestaFile(
    "/Solicitud/insertInterno"
  ),
  cmbEstatusComentario: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/cmbEstatusComentario"
  ),
  personasByProy: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/personasByProy"
  ),
  subgruposAll: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Catalogos/subgruposAll"
  ),
  graficaGrupoMes: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Catalogos/graficaGrupoMes"
  ),
  propuestaCreate: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/propuestaCreate"
  ),
  requerimientosCreate: ServiciosGeneral.llamarServidorRespuestaFile(
    "/Solicitud/requerimientosCreate"
  ),
  datosUpdate: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/datosUpdate"
  ),
  propuestaUpdate: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/propuestaUpdate"
  ),
  ctlSolicitud: ServiciosGeneral.llamarServidorRespuestaPost("/Solicitud/ctlSolicitud"),

  tareasCreate: ServiciosGeneral.llamarServidorRespuesta(
    "/Tareas/tareasCreate"
  ),
  tareasUpdate: ServiciosGeneral.llamarServidorRespuesta("Tareas/tareasUpdate"),
  cerrartareasUpdate: ServiciosGeneral.llamarServidorRespuesta(
    "Tareas/cerrartareasUpdate"
  ),
  tareasAll: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/tareasAll"),
  tareasDown: ServiciosGeneral.llamarServidorRespuestaPost(
    "Tareas/tareasCambioEstatus"
  ),
  cambioEstatus: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/cambioEstatus"
  ),
  tareasResponsables: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Tareas/tareaResponsables"
  ),
  seguimientosResponsables: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Seguimiento/seguimientoResponsables"
  ),
  incidenciasResponsables: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Incidencia/incidenciaResponsables"
  ),
  tareasHoras: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Tareas/tareasHoras"
  ),
  buscarInformacionPanel: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Tareas/buscarInformacionPanel"
  ),
  propuestaUpdateD: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/propuestaUpdateD"
  ),
  /* SEGUIMIENTOS */
  seguimientosAll: ServiciosGeneral.llamarServidorRespuestaPost(
    "Seguimiento/seguimientosAll"
  ),
  seguimientosIncidencia: ServiciosGeneral.llamarServidorRespuestaPost(
    "Seguimiento/seguimientosIncidencia"
  ),
  seguimientosCreate: ServiciosGeneral.llamarServidorRespuesta(
    "/Seguimiento/seguimientosCreate"
  ),
  seguimientoUpdate: ServiciosGeneral.llamarServidorRespuesta(
    "Seguimiento/seguimientoUpdate"
  ),
  PersonasSeguimiento: ServiciosGeneral.llamarServidorRespuestaPost(
    "Seguimiento/personaSeguimiento"
  ),

  /* INDICADORES */
  IndicadoresTarea: ServiciosGeneral.llamarServidorRespuestaPost(
    "Indicadores/IndicadorTarea"
  ),
  IndicadoresTareaByselect: ServiciosGeneral.llamarServidorRespuestaPost(
    "Indicadores/IndicadoresTareaByselect"
  ),
  PersonasTarea: ServiciosGeneral.llamarServidorRespuestaPost(
    "Indicadores/personaTarea"
  ),
  PersonaIncidencia: ServiciosGeneral.llamarServidorRespuestaPost(
    "Indicadores/personaIncidencia"
  ),
  PersonaSeguimiento: ServiciosGeneral.llamarServidorRespuestaPost(
    "Indicadores/personaSeguimiento"
  ),

  /*SOLICITUD DE MEJORA */
  BuscarsolMejora: ServiciosGeneral.llamarServidorRespuestaPost(
    "ModificacionAlcance/BuscarsolMejora"
  ),

  AllMalcance: ServiciosGeneral.llamarServidorRespuestaPost(
    "ModificacionAlcance/AllMalcance"
  ),
  cmbEstatusComentarioMAlcance: ServiciosGeneral.llamarServidorRespuesta(
    "ModificacionAlcance/cmbEstatusComentarioMAlcance"
  ),
  datosUpdateMAlcance: ServiciosGeneral.llamarServidorRespuestaPost(
    "ModificacionAlcance/datosUpdateMAlcance"
  ),
  datosSolicitudMalcance: ServiciosGeneral.llamarServidorRespuestaPost(
    "ModificacionAlcance/datosSolicitudMalcance"
  ),
  propuestaMACreate: ServiciosGeneral.llamarServidorRespuesta(
    "ModificacionAlcance/propuestaMACreate"
  ),
  datosUpdateProp_ma: ServiciosGeneral.llamarServidorRespuestaPost(
    "ModificacionAlcance/datosUpdateProp_ma"
  ),
  propuestaUpdateMAlcance: ServiciosGeneral.llamarServidorRespuesta(
    "/ModificacionAlcance/propuestaUpdateMAlcance"
  ),
  propuestaUpdateDMAlcance: ServiciosGeneral.llamarServidorRespuesta(
    "/ModificacionAlcance/propuestaUpdateDMAlcance"
  ),
  cambioEstatusMAlcance: ServiciosGeneral.llamarServidorRespuesta(
    "/ModificacionAlcance/cambioEstatusMAlcance"
  ),
  /* SEGIMIENTOS */

  solicitudesSelects: ServiciosGeneral.llamarServidor(
    "/Solicitud/solicitudesSelects"
  ),
  seguimientosIncidencia: ServiciosGeneral.llamarServidorRespuestaPost(
    "Seguimiento/seguimientosIncidencia"
  ),
  incidenciaCreate: ServiciosGeneral.llamarServidorRespuesta(
    "/Incidencia/incidenciaCreate"
  ),
  integrantesCreate: ServiciosGeneral.llamarServidorRespuesta(
    "/Incidencia/integrantesCreate"
  ),
  incidenciaUpdate: ServiciosGeneral.llamarServidorRespuesta(
    "Incidencia/incidenciaUpdate"
  ),

  /* OBSERVACIONES */
  getObservaciones: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/getObservaciones"
  ),
  getObservacionesMalcance: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/getObservacionesMalcance"
  ),
  inserComentario: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/inserComentario"
  ),
  getAllcomentarios: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/getAllcomentarios"
  ),

  /* ARCHIVOS*/
  getDocumentos: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/documentos"
  ),

  /* ARCHIVOS MODIFICACION ALCANCE*/
  getDocumentosMalcance: ServiciosGeneral.llamarServidorRespuestaPost(
    "/ModificacionAlcance/documentos"
  ),

   /* DOCUMENTOS DE REQUERIMIENTOS */
  getDocumentosReq: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/documentosReq"
  ),

  getSolicitudesByestatus: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/getSolicitudesByestatus"
  ),

  insertMA: ServiciosGeneral.llamarServidorRespuestaFile(
    "/ModificacionAlcance/insertInternoMA"
  ),
  requerimientosMACreate: ServiciosGeneral.llamarServidorRespuestaFile(
    "/ModificacionAlcance/requerimientosMACreate"
  ),
  saveFechaPresentacion: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/saveFechaPresentacion"
  ),
  saveIncidenciaReq: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/saveIncidenciaReq"
  ),
  getEquipo: ServiciosGeneral.llamarServidorRespuestaPost(
    "/Solicitud/getEquipo"
  ),
  finalizarSol: ServiciosGeneral.llamarServidorRespuesta(
    "/Solicitud/finalizarSol"
  ),
  saveFechaPresentacionMA: ServiciosGeneral.llamarServidorRespuesta(
    "/ModificacionAlcance/saveFechaPresentacionMA"
  ),
  finalizarMA: ServiciosGeneral.llamarServidorRespuesta(
    "/ModificacionAlcance/finalizarMA"
  ),
  // estadoAll:llamarServidor('catalogos/estadoAll'),
  getHrsHombre: ServiciosGeneral.llamarServidorRespuestaPost(
    "Tareas/array_horas"
  ),
  getHrsHombreUpd: ServiciosGeneral.llamarServidorRespuestaPost(
    "Tareas/array_horas_upd"
  ),
  getTarea_S: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/getTarea_S"),
  getTarea_A: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/getTarea_A"),
  getTarea_T: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/getTarea_T"),
  getSegInc: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/getSegInc"),
  // getTarea_T: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/getTarea_T"),
  tareasCreateSol: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/tareasCreateSol"),
  guardacalificacion: ServiciosGeneral.llamarServidorRespuestaPost("/Solicitud/calificacion"),
  /*** Reportes x sistema ***/
  getInfoGeneral: ServiciosGeneral.llamarServidorRespuestaPost('/Reportes/getinfoProyecto'),
};
export default servicios;
